import { ThemeButtonImage } from '@shared/ui/buttons';
import { useTopUpBalanceDialog } from '@utils/dialogs-hooks';
import { useTranslation } from 'react-i18next';

export default function TopUpBalanceBtn() {
  const { openTopUpDialog } = useTopUpBalanceDialog();
  const { t } = useTranslation();

  return (
    <ThemeButtonImage
      name="top-up-balance"
      animation="rotate-x"
      onClick={openTopUpDialog}
    >
      {t('top_up_balance')}
    </ThemeButtonImage>
  );
}
